"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAutoLogin = void 0;
var _react = require("react");
const useAutoLogin = () => {
  const handleAutoLogin = (0, _react.useCallback)(async (url, data) => {
    const form = document.createElement('form');
    const userName = document.createElement('input');
    const password = document.createElement('input');
    const returnUrl = document.createElement('input');
    form.method = 'POST';
    form.action = url;
    form.style.display = 'none';
    password.name = 'Password';
    password.value = data.Password;
    userName.name = 'UserName';
    userName.value = data.UserName;
    returnUrl.name = 'ReturnUrl';
    returnUrl.value = data.ReturnUrl;
    form.append(password);
    form.append(userName);
    form.append(returnUrl);
    document.body.append(form);
    form.submit();
  }, []);
  return {
    handleAutoLogin
  };
};
exports.useAutoLogin = useAutoLogin;
